module.exports = __webpack_public_path__ + "img/3_user.24aecead.svg";